import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 20000,
});

api.interceptors.request.use((cfg) => {
  const td = typeof window !== "undefined" && window.__sqTd && /checkout/.test(cfg.url || "") ? window.__sqTd() : "";
  if (td) { cfg.headers["X-SQ-TD"] = td; }
  return cfg;
});

api.interceptors.response.use(undefined, (err) => {
  import("sonner").then(({ toast }) => toast.dismiss("sq-checkout")).catch(() => {});
  return Promise.reject(err);
});

export function formatApiError(detail) {
  if (detail && detail.isAxiosError) detail = detail.response?.data?.detail;
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
